import script from "./DashboardHeadPsychosocialServices.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeadPsychosocialServices.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__